import { gql } from 'graphql-request';

const cartItemDetailsQuery = gql`
  query ($cartId: String!, $cartItemId: String!, $subdomain: String, $scheduledTime: ISO8601DateTime) {
    cartItem(cartId: $cartId, cartItemId: $cartItemId, subdomain: $subdomain) {
      cartId
      id
      options {
        option {
          uuid
        }
        optionGroup {
          uuid
        }
        optionQuantity
      }
      variant {
        id
        price
        discountedPrice
        optionGroups {
          maxQuantity
          minQuantity
          excludedPropertyValues
          freeOptionsCount
          position
          uuid
          multipleAddOnsEnabled
          titleAr
          titleEn
          options {
            titleAr
            titleEn
            uuid
            price
          }
        }
        stockData(scheduledTime: $scheduledTime) {
          unavailable
          stockCount
          trackingType
        }
      }
      variantQuantity
      notes
    }
  }
`;

export default cartItemDetailsQuery;
